module.exports = __webpack_public_path__ + "assets/img/c32.efb2f689.png";